<template>
  <div class="container-fluid">
    <modalcancel :id="num_reserva"></modalcancel>
    <loader />
    <div class="text-right">
      <b-button
        squared
        class="button mb-4"
        :to="{ name: 'international-destination' }"
        ><i class="fa-solid fa-plane-up"></i>&nbsp;{{
          $t('destinos_internacionales')
        }}</b-button
      >
    </div>
    <div class="" v-show="!modificar">
      <b-row>
        <b-col md="8">
          <h3 class="heavy text-uppercase">
            {{ $t('nueva_reserva.titulo_paso1') }}
          </h3>
        </b-col>
        <b-col md v-if="!auth">
          <a
            href=""
            @click.prevent="modificar = !modificar"
            class="bold green float-right"
            ><span>{{ $t('reserve_step1and2.or') }}</span
            >{{ $t('reserve_step1and2.modify') }}</a
          >
        </b-col>
        <!--si está autenticado-->
        <b-col md v-else>
          <router-link
            :to="{ name: 'Panel' }"
            style="font-size: 19px"
            class="bold green float-right"
            >RESERVAS ACTIVAS</router-link
          >
        </b-col>
        <!--si está autenticado-->
      </b-row>
      <div class="">
        <p class="light text-uppercase">
          <b>{{ $t('reserve_step1and2.office_label') }}</b>
          <span class="medium text-capitalize"
            >({{ $t('reserve_step1and2.city_label') }})</span
          >*
        </p>
      </div>
      <div class="">
        <div class="">
          <!-- <input type="text" class="input-large" placeholder="pick-up location" autocomplete="off"> -->
          <div class="borderdiv">
            <select
              name=""
              id=""
              class="input-sucursal"
              v-model="data.sucursal_retiro"
              @change="cambioSucursal($event.target.selectedIndex)"
            >
              <template v-for="(item, index) in sucursales">
                <!-- Renderizar el encabezado de región si el region_id cambia -->
                <option
                  v-if="
                    index === 0 ||
                      item.region_id !== sucursales[index - 1].region_id
                  "
                  disabled
                  class="readonly-option"
                >
                  <b>-{{ regionName(item.region_id) }}</b>
                </option>
                <!-- Renderizar las opciones -->
                <option
                  v-show="item.enterprise == 1"
                  :value="item.id"
                  :key="item.id"
                >
                  {{ item.nombre_web }}
                </option>
              </template>
            </select>
          </div>
        </div>
      </div>
      <div class="">
        <div class="">
          <!-- <input type="checkbox" id="ck" class="input-check" @click="devolverOtraSucursal"> 
          <label for="ck" class="ml-2"> Devolver en otra oficina</label>
         -->
          <label class="customcheck mt-4"
            >{{ $t('reserve_step1and2.return_label') }}
            <input type="checkbox" v-model="otra_sucursal" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="" v-show="otra_sucursal">
        <div class="" style="line-height: 1px;">
          <p class="light text-uppercase">
            <b>{{ $t('reserve_step1and2.office_dev') }}</b>
            <span class="medium text-capitalize"
              >({{ $t('reserve_step1and2.city_label') }})</span
            >*
          </p>
        </div>
      </div>

      <div class="" v-show="otra_sucursal">
        <div class="">
          <div class="borderdiv">
            <select
              name=""
              id=""
              class="input-sucursal"
              v-model="data.sucursal_devolucion"
            >
              <template v-for="(item, index) in sucursales">
                <!-- Renderizar el encabezado de región si el region_id cambia -->
                <option
                  v-if="
                    index === 0 ||
                      item.region_id !== sucursales[index - 1].region_id
                  "
                  disabled
                  class="readonly-option"
                >
                  <b>-{{ regionName(item.region_id) }}</b>
                </option>
                <!-- Renderizar las opciones -->
                <option
                  v-show="item.enterprise == 1"
                  :value="item.id"
                  :key="item.id"
                  @click="cambioSucursal(item)"
                >
                  {{ item.nombre_web }}
                </option>
              </template>
            </select>
          </div>
        </div>
      </div>

      <b-row>
        <b-col md="">
          <div class="mt-1">
            <p class="light text-uppercase">
              <b>{{ $t('reserve_step1and2.pick_date_label') }}*</b>
            </p>
          </div>
          <b-row class="m-1">
            <!-- v-click-outside="closeCalendar1" -->
            <b-col class="no-padding" v-click-outside="closeCalendar1">
              <div
                class="borderdiv pt custom-select2"
                style="border-right:none"
                @click="calendario_retiro = !calendario_retiro"
              >
                <label class="green day pt">{{ day(data.fecha_retiro) }}</label>
                <label class="medium mouth pt"
                  >{{ month(data.fecha_retiro) }}<br />{{
                    year(data.fecha_retiro)
                  }}</label
                >
              </div>
              <div v-if="$i18n.locale === 'en'">
                <b-calendar
                  locale="en-US"
                  :min="minCalendar"
                  :max="maxCalendar"
                  today-variant="primary"
                  v-show="calendario_retiro"
                  v-model="fecha_retiro"
                  @context="onContextRetiro"
                  :date-disabled-fn="dateDisabled"
                ></b-calendar>
              </div>
              <div v-else>
                <b-calendar
                  :min="minCalendar"
                  :max="maxCalendar"
                  locale="es-ES"
                  today-variant="primary"
                  v-show="calendario_retiro"
                  v-model="fecha_retiro"
                  @context="onContextRetiro"
                  :date-disabled-fn="dateDisabled"
                ></b-calendar>
              </div>
            </b-col>
            <b-col class="no-padding">
              <div class="borderdiv bckhour">
                <select
                  class="custom-select selectHora"
                  v-model="data.hora_retiro"
                >
                  <option
                    class="horas"
                    :value="item"
                    :key="item"
                    v-for="item in horasDynamic"
                    >{{ item }}</option
                  >
                </select>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <!--fecha y hora de devolución-->
        <b-col md="">
          <div class="mt-1">
            <p class="light text-uppercase">
              <b>{{ $t('reserve_step1and2.return_date_label') }}*</b>
            </p>
          </div>
          <b-row class="m-1">
            <!-- v-click-outside="closeCalendar1" -->
            <b-col class="no-padding" v-click-outside="closeCalendar2">
              <div
                class="borderdiv pt custom-select2"
                style="border-right:none"
                @click="calendario_devolucion = !calendario_devolucion"
              >
                <label class="green day pt">{{
                  day(data.fecha_devolucion)
                }}</label>
                <label class="medium mouth pt"
                  >{{ month(data.fecha_devolucion) }}<br />{{
                    year(data.fecha_devolucion)
                  }}</label
                >
              </div>
              <div v-if="$i18n.locale === 'en'">
                <b-calendar
                  locale="en-US"
                  :min="minCalendar"
                  :max="maxCalendar"
                  today-variant="primary"
                  v-show="calendario_devolucion"
                  v-model="fecha_devolucion"
                  @context="onContextRetiro"
                  :date-disabled-fn="dateDisabled"
                ></b-calendar>
              </div>
              <div v-else>
                <b-calendar
                  :min="minCalendar"
                  :max="maxCalendar"
                  locale="es-ES"
                  today-variant="primary"
                  v-show="calendario_devolucion"
                  v-model="fecha_devolucion"
                  @context="onContextdevol"
                  :date-disabled-fn="dateDisabled"
                ></b-calendar>
              </div>
            </b-col>
            <b-col class="no-padding">
              <div class="borderdiv bckhour">
                <select
                  class="custom-select selectHora"
                  v-model="data.hora_devolucion"
                >
                  <option
                    class="horas"
                    :value="item"
                    :key="item"
                    v-for="item in horasDynamic"
                    >{{ item }}</option
                  >
                </select>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <!--fecha y hora de devolución-->
        <b-col md="4">
          <div class="mt-1">
            <p class="light text-uppercase">
              <b>{{ $t('reserve_step1and2.age_label') }}*</b>
            </p>
          </div>
          <div class="borderdiv " style="height:76px;">
            <select
              class=" selectEdad flecha "
              style="height:72px;"
              v-model="data.edad"
            >
              <option class="edad" :value="'23'">23</option>
              <option class="edad" :value="'24'">24</option>
              <option class="edad" :value="'25'">25+</option>
            </select>
          </div>
        </b-col>
      </b-row>
      <br />
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="warning"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
      >
        {{ $t('alert_sucursal') }}
      </b-alert>
      <b-row>
        <b-col md="4" class="mt-2 ">
          <!-- <input type="text" class="input-large borderdiv" placeholder="código promocional o número de cuenta (opcional)" autocomplete="off">
          <br> -->
          <b-button block squared @click="redirectPromo" class="button"
            >{{ $t('buttons_label.ver_promos') }}&nbsp;<i
              class="fa-regular fa-share-from-square"
            ></i
          ></b-button>
        </b-col>
        <b-col md="4" class="mt-2 ml-auto">
          <!-- <button class="btnr" @click="preCalculo">Continue</button> -->
          <b-button
            v-if="$route.name === 'Fleet'"
            block
            squared
            @click="tercerPaso(vehiculo_id)"
            class="button"
            >{{ $t('buttons_label.continue') }}</b-button
          >
          <b-button
            v-else-if="$route.name === 'promoes'"
            block
            squared
            @click="paso_promo_especial()"
            class="button"
            >{{ $t('buttons_label.continue') }}</b-button
          >
          <b-button
            v-else
            block
            squared
            @click="segundoPaso"
            class="button"
            :disabled="condicionDeDeshabilitar"
            >{{ $t('buttons_label.continue') }}</b-button
          >
          <br />
        </b-col>
      </b-row>
    </div>
    <!-- start modify section-->
    <div class="" v-if="modificar == true && viewDetails == false">
      <form
        @submit.prevent="
          buscarReserva({ num_reserva, apellido_paterno, brand: 3 })
        "
      >
        <b-row>
          <b-col md="8">
            <h3 class="heavy2 text-uppercase">
              {{ $t('reserve_step1and2.modify') }}
            </h3>
          </b-col>
          <b-col md>
            <a
              href=""
              @click.prevent="modificar = !modificar"
              class="float-right bold green text-uppercase"
              ><span>O</span>{{ $t('nueva_reserva.titulo_paso1') }}</a
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div v-show="errors.error" class="box-error">
              <strong>ERROR:</strong>
              <span v-if="$i18n.locale === 'es'" class="msg-error">
                {{ errors.es }}
              </span>
              <span v-else class="msg-error">
                {{ errors.en }}
              </span>
            </div>
            <p class="light">
              {{ $t('Modify_view_table.numero_label')
              }}<span class="medium"></span>
            </p>
            <input
              type="number"
              class="input-large"
              placeholder=""
              autocomplete="off"
              v-model="num_reserva"
              required
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <p class="light">
              {{ $t('Modify_view_table.lastname_label')
              }}<span class="medium"></span>
            </p>
            <input
              type="text"
              class="input-large"
              placeholder=""
              autocomplete="off"
              v-model="apellido_paterno"
              required
            />
          </b-col>
        </b-row>
        <br />
        <!--mobile-->
        <b-row>
          <b-col class="d-lg-none">
            <button class="btn btn-success btnr float-right">
              {{ $t('Modify_view_table.btn_label') }}
            </button>
          </b-col>
        </b-row>
        <!--mobile-->
        <b-row>
          <b-col class="d-none d-lg-block"> </b-col>
          <b-col class="d-none d-lg-block"> </b-col>
          <b-col class="d-none d-lg-block">
            <button class="btn btn-success btnr float-right rounded-0">
              {{ $t('Modify_view_table.btn_label') }}
            </button>
          </b-col>
        </b-row>
      </form>
    </div>
    <!-- end modify section-->
    <!--resultado de la busqueda-->
    <div class="" v-if="viewDetails">
      <!--primer row-->
      <b-row>
        <b-col>
          <h3 class="heavy2 text-uppercase">
            {{ $t('reserve_step1and2.modify') }}
          </h3>
        </b-col>
        <b-col>
          <a href="" @click.prevent="reservar" class="float-right bold green"
            ><span>{{ $t('reserve_step1and2.or') }}</span
            >{{ $t('reserve_step1and2.title') }}</a
          >
        </b-col>
      </b-row>
      <!--fin primer row-->

      <!--segundo row-->
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-header">
              <h5>{{ fecha_retiro_corta }} - {{ fecha_entrada_corta }}</h5>
              <span>{{ $t('modify.mod2') }} {{ getReserve.id }}</span> |
              <b-button
                @click="
                  detallesReserva({ num_reserva: getReserve.id, brand: 3 })
                "
                variant="link"
                class="btnlinks text-uppercase"
                >{{ $t('modify.mod10') }}</b-button
              >
              |
              <b-button
                @click="
                  cargaReservaEdit({ num_reserva: getReserve.id, brand: 3 })
                "
                variant="link"
                class="btnlinks text-uppercase"
                >{{ $t('step5.st8') }}</b-button
              >
              |
              <b-button
                class="btnlinks text-uppercase"
                variant="link"
                data-toggle="modal"
                data-target="#cancelModal"
                >{{ $t('modify.mod11') }}
              </b-button>

              <img :src="getReserve.auto.image.url_imagen" alt="" class="car" />
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <p class="titleDetails">PICK-UP</p>
                  <span>{{ getReserve.retiro.nombre_web }}</span
                  ><br />
                  <span>{{ getReserve.fecha_salida }}</span>
                </b-col>

                <b-col>
                  <p class="titleDetails">RETURN</p>
                  <span>{{ getReserve.devolucion.nombre_web }}</span
                  ><br />
                  <span>{{ getReserve.fecha_entrada }}</span>
                </b-col>

                <b-col>
                  <p class="titleDetails">VEHICLE</p>
                  <span
                    >{{ getReserve.auto.marca }} {{ getReserve.auto.modelo }} or
                    similar</span
                  >
                  <br />
                  <span
                    ><i class="icon-transmission ic"></i>
                    {{ getReserve.auto.transmision }}</span
                  >
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <!--fin segundo row-->

      <div class="row">
        <div class="col-6">
          <!-- <h3 class="heavy text-uppercase">{{$t('reserve_step1and2.modify')}}</h3> -->
        </div>
        <div class="col-6">
          <!-- <a href="" @click.prevent="reservar" class="float-right bold green"><span>O</span>REALIZAR UNA RESERVA</a> -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <br />
          <button class="btn btn-outline-success float-right rounded-0">
            {{ $t('modify.mod12') }}
          </button>
        </div>
      </div>
    </div>
    <!--resultado de la busqueda-->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import '@fortawesome/fontawesome-free/css/all.css'
import loader from '@/components/loader.vue'
import modalcancel from '@/components/ModalCancelReserve'
import moment from 'moment'
import ClickOutside from 'vue-click-outside'
export default {
  components: {
    loader,
    modalcancel
  },
  /* metaInfo:{
      title: "Reservar con enterprise Panamá",
      meta: [{
        vmid: 'Enterprise Panamá',
        name: 'description',
        content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
      }]
    }, */
  directives: {
    ClickOutside
  },
  mounted() {
    this.MT_VALORESPORDEFECTO()
    this.primerPaso()

    if (this.$route.name == 'promoes') {
      this.data.sucursal_retiro = 3
      this.data.sucursal_devolucion = 3
    }

    //console.log('nombre de ruta ' + this.$route.name)
    //console.log('suc retiro ' + this.data.sucursal_retiro)
    //console.log('suc devolución ' + this.data.sucursal_devolucion)
  },
  data() {
    return {
      modificar: false,
      otra_sucursal: false,
      calendario_retiro: false,
      calendario_devolucion: false,
      num_reserva: '',
      apellido_paterno: '',
      contextR: '',
      contextD: '',
      horasDynamic: this.generateTimeOptions('06:00', '06:00'),
      diasDeshabilitados: [0],
      condicionDeDeshabilitar: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  watch: {
    otra_sucursal() {
      //console.log("otra sucursal")
      if (!this.otra_sucursal) {
        this.data.sucursal_devolucion = this.data.sucursal_retiro
      }
    },
    welcome(newValue, oldValue) {
      if (newValue) {
        this.showWelcome()
      }
    },
    verifyEmail(newValue, oldValue) {
      if (newValue) {
        this.messageVerifyEmail()
      }
    },
    'data.fecha_devolucion'(newValue, oldValue) {
      if (this.data.fecha_retiro > newValue) {
        this.contextD = this.data.fecha_retiro
        this.data.fecha_devolucion = this.data.fecha_retiro
      }
    },
    'data.fecha_retiro'(newValue, oldValue) {
      if (this.data.fecha_devolucion < newValue) {
        this.contextR = this.data.fecha_retiro
        this.data.fecha_devolucion = this.data.fecha_retiro
      }
    }
  },
  computed: {
    ...mapState('reservav2', [
      'sucursales',
      'data',
      'horas',
      'loader',
      'getReserve',
      'viewDetails',
      'auto',
      'vehiculo_id',
      'errors'
    ]),
    ...mapState('autenticacion', [
      'auth',
      'welcome',
      'modoClientes',
      'verifyEmail'
    ]),
    minCalendar() {
      return moment().format('YYYY-MM-DD')
    },
    maxCalendar() {
      return moment()
        .add(1, 'years')
        .format('YYYY-MM-DD')
    },
    fecha_retiro: {
      get() {
        if (this.$route.name === 'Weekend') {
          let day = moment()
            .day(5)
            .format('YYYY-MM-DD')
          //console.log(day);
          return day
        } else if (this.$route.name === 'Greenweek') {
          let day1 = moment().format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Pack3d') {
          let day1 = moment().format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Pack4d') {
          let day1 = moment().format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Bymonth') {
          let day1 = moment().format('YYYY-MM-DD')
          return day1
        } else {
          let day = moment()
            .add(2, 'days')
            .format('YYYY-MM-DD')
          return day
        }
      },
      set(date) {
        //console.log(date);
      }
    },
    fecha_devolucion: {
      get() {
        if (this.$route.name === 'Weekend') {
          let day = moment()
            .day(5)
            .format('YYYY-MM-DD')
          let day1 = moment(day)
            .add(3, 'days')
            .format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Greenweek') {
          let day = moment().format('YYYY-MM-DD')
          let day1 = moment(day)
            .add(7, 'days')
            .format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Pack3d') {
          let day = moment().format('YYYY-MM-DD')
          let day1 = moment(day)
            .add(3, 'days')
            .format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Pack4d') {
          let day = moment().format('YYYY-MM-DD')
          let day1 = moment(day)
            .add(4, 'days')
            .format('YYYY-MM-DD')
          return day1
        } else if (this.$route.name === 'Bymonth') {
          let day = moment().format('YYYY-MM-DD')
          let day1 = moment(day)
            .add(30, 'days')
            .format('YYYY-MM-DD')
          return day1
        } else {
          let day = moment().format('YYYY-MM-DD')
          let day1 = moment(day)
            .add(4, 'days')
            .format('YYYY-MM-DD')
          return day1
        }
      },
      set(date) {
        //console.log(date);
      }
    },
    fecha_retiro_corta() {
      return moment(this.getReserve.fecha_salida, 'YYYY-MM-DD HH:mm:ss').format(
        'dddd, D [de] MMMM [de] YYYY'
      )
    },
    fecha_entrada_corta() {
      return moment(
        this.getReserve.fecha_entrada,
        'YYYY-MM-DD HH:mm:ss'
      ).format('dddd, D [de] MMMM [de] YYYY')
    }
  },
  methods: {
    ...mapActions('reservav2', [
      'primerPaso',
      'segundoPaso',
      'buscarReserva',
      'detallesReserva',
      'cargaReservaEdit',
      'tercerPaso'
    ]),
    ...mapMutations('reservav2', ['MT_VALORESPORDEFECTO', 'MT_MIRUTA']),
    ...mapMutations('autenticacion', ['WELCOME', 'VERIFYEMAIL']),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    dateDisabled(ymd, date) {
      // Iterate over the sucursales array
      for (let i = 0; i < this.sucursales.length; i++) {
        const element = this.sucursales[i]
        // Check if the current sucursal matches the selected one
        if (element.id === this.data.sucursal_retiro) {
          // Check if the sucursal is closed on Sundays
          if (element.horario_domingo === 'CERRADO') {
            // Disable Sundays (weekday = 0)
            return date.getDay() === 0
          }
        }
      }
      // Return false by default (no dates disabled)
      return false
    },
    generateTimeOptions(startTime, endTime) {
      const start = startTime.split(':').map(Number)
      const end = endTime.split(':').map(Number)
      const options = []

      let current = [...start]
      do {
        options.push(
          `${current[0]
            .toString()
            .padStart(2, '0')}:${current[1].toString().padStart(2, '0')}`
        )

        current[1] += 30
        if (current[1] >= 60) {
          current[0]++
          current[1] -= 60
        }
        if (current[0] === 24) {
          current[0] = 0
        }
      } while (!(current[0] === end[0] && current[1] === end[1]))

      return options
    },
    cambioSucursal(s) {
      const selectedItem = this.sucursales[s - 1]

      const HorWeek = !selectedItem.horario_sem
        ? '00:00-23:59'
        : selectedItem.horario_sem
      const HorWeekArray = HorWeek.split('-')

      //Calcular horario sucursal 24 horas
      const HorForever = '06:00-06:00'
      const HorForeverArray = HorForever.split('-')

      this.horasDynamic = this.generateTimeOptions(
        HorWeek === '00:00-23:59' ? HorForeverArray[0] : HorWeekArray[0],
        HorWeek === '00:00-23:59' ? HorForeverArray[1] : HorWeekArray[1]
      )

      //this.setHorario(s.horario_sem, s.horario_sabado, s.horario_domingo)
      if (!this.otra_sucursal) {
        this.data.sucursal_devolucion = this.data.sucursal_retiro
      }

      this.data.hora_retiro = '10:00'
      this.data.hora_devolucion = '10:00'
    },
    paso_promo_especial() {
      let ruta_actual = this.$route.fullPath
      let current_page = ruta_actual.substring(3, 22) ///promocion-especial
      //console.log('la pagina current page mi ruta ' + current_page)
      this.MT_MIRUTA(current_page)
      let auto_id = this.$route.params.id
      this.tercerPaso(auto_id)
    },
    showWelcome() {
      setTimeout(() => {
        this.WELCOME()
      }, 4000)
    },
    messageVerifyEmail() {
      setTimeout(() => {
        this.VERIFYEMAIL()
      }, 4000)
    },
    day(d) {
      return moment(d).format('D')
    },

    // metodo para mostrar el mes
    month(m) {
      return moment(m).format('MMM')
    },

    // metodo para mostrar el año
    year(y) {
      return moment(y).format('YYYY')
    },
    onContextRetiro(ctx) {
      this.contextR = ctx.activeYMD
      this.data.fecha_retiro = this.contextR

      // Aquí puedes verificar si el día seleccionado está deshabilitado
      if (ctx.disabled) {
        this.condicionDeDeshabilitar = true
        this.showAlert()
      } else {
        this.condicionDeDeshabilitar = false
      }
    },

    onContextdevol(ctx) {
      this.contextD = ctx.activeYMD
      this.data.fecha_devolucion = this.contextD

      // Aquí puedes verificar si el día seleccionado está deshabilitado
      if (ctx.disabled) {
        this.condicionDeDeshabilitar = true
        this.showAlert()
      } else {
        this.condicionDeDeshabilitar = false
      }
    },
    closeCalendar1() {
      this.calendario_retiro = false
    },
    closeCalendar2() {
      this.calendario_devolucion = false
    },
    redirectPromo() {
      this.$router.push('promo/promo')
    },
    regionName(region_id) {
      switch (region_id) {
        case 1:
          return 'PROVINCIA DE PANAMÁ'
          break
        case 2:
          return 'PROVINCIA DE CHIRIQUÍ'
          break
        case 3:
          return 'PROVINCIA DE COCLÉ'
          break
        default:
          return 'PROVINCIA DESCONOCIDA'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'DIN 2014-ExraBold';
  src: url('../../assets/fonts/DIN2014-ExtraBold.ttf');
}
@font-face {
  font-family: 'DIN 2014-Regular';
  src: url('../../assets/fonts/DIN2014-Regular.ttf');
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}

.heavy {
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, Helvetica, sans-serif;
  font-size: 32px;
  line-height: 36px;
}
.heavy2 {
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, Helvetica, sans-serif;
  font-size: 30px;
  line-height: 36px;
}
a {
  line-height: 36px;
  span {
    color: #c3c3c3;
    margin-top: 2px;
    margin-right: 7px;
  }
}

.green,
.green:hover {
  color: #169a5a;
}
.bold {
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, sans-serif;
  font-size: 15px;
}
.light {
  font-family: 'DIN 2014-Regular', Helvetica, Arial, sans-serif;
  font-size: 15px;
  padding-top: 33px;
  color: #181918;
}
.medium {
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 15px;
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.input-large {
  border: 1px solid #c2c2c2;
  height: 60px;
  padding-left: 15px;
  font-size: 20px;
  width: 100%;
}
.input-sucursal {
  border: none;
  height: 60px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 20px;
  width: 99.9%;
  background: url('/img/flecha.png') no-repeat right/15px;
  background-position: 98% 24px;
  background-color: rgb(255, 255, 255);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.input-sucursal:focus {
  outline: 2px solid #a4ceff !important;
}
.input-check {
  margin-top: 1.5%;
}
.btnr {
  background-color: #169a5a;
  color: white;
  border-radius: 0%;
  width: 100%;
  height: 100%;
}
.button {
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  color: #ffffff;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background: #169a5a;
  height: 100%;
  border: none;
}
.button:hover {
  background: #006639;
}
.date {
  margin-left: 0%;
}
.day {
  padding-top: 10px;
  padding-left: 15px;
  font-size: 43px;
  line-height: 53px;
}
.mouth {
  padding-top: 8px;
  font-size: 13px;
  height: 19px;
  padding-bottom: 5px;
}
.fa-arrow-right {
  padding: 25px 27px;
}
.col-sm-1 {
  max-width: 7%;
}
.edad {
  margin-left: 3%;
  max-width: 22%;
}

.selectHora {
  width: 100%;
  font-size: 38px;
  border: none;
  color: #169a5a;
  padding: 0px;

  .horas {
    color: rgb(27, 27, 27);
    font-size: 16px;
  }
}
.bckhour {
  background-color: #f3f3f3;
}
.custom-select {
  background: url('/img/flecha.png') no-repeat right/15px;
  background-position: 95% 30px;
  //background-color: #f3f3f3;
  border: 0px #ffffff;
  border-radius: 0rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.custom-select2 {
  background: url('/img/flecha.png') no-repeat right/15px;
  background-position: 95% 30px;
  background-color: rgb(255, 255, 255);
  border: 0px #ffffff;
  border-radius: 0rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.pt {
  cursor: pointer;
}
.flecha {
  background: url('/img/flecha.png') no-repeat right/15px;
  background-position: 95% 30px;
  /*  position: float;
    margin-top: 21%;
    margin-left: 12%;
    right: 0%;
    width: 10%; */
}

.selectEdad {
  padding-left: 5%;
  width: 100%;
  height: 83%;
  background-color: #ffffff;
  font-size: 20px;
  border: none;
  color: #181918;

  /* padding: 7px; */

  .edad {
    color: rgb(15, 15, 15);
    font-size: 16px;
  }
}
.selectEdad:focus {
  outline: 2px solid #a4ceff !important;
}
.card {
  border-radius: 0px;
}
.btnlinks {
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, sans-serif;
  color: #169a5a;
  font-weight: 900;
  font-size: 15px;
}

.icon-transmission {
  background-image: url('/img/transmission_type.svg');
  background-size: 100%;
  background-repeat: no-repeat;
}
.ic {
  display: inline-block;
  width: 17px;
  height: 16px;
}
.titleDetails {
  font-weight: bold;
}
.car {
  float: right;
  // margin-right: -10%;
  margin-top: -7%;
}

.titles2 {
  color: #181918;
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  height: 20px;
}
.borderdiv {
  border-radius: 0px;
  border: solid 2px #b8b8b8;
}
.borderdiv:focus {
  outline: 2px solid #a4ceff !important;
}

/* /////////// CHECKBOX //////////////  */
/* The customcheck */
.customcheck {
  display: block;
  position: relative;
  padding-left: 35px;
  padding-top: 5px;
  margin-bottom: 22px;
  font-size: 14px;
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  /* margin-left: -14px; */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.customcheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 28px;
  width: 28px;
  background-color: rgb(255, 255, 255);
  border-radius: 0px;
  border: solid 2px #b8b8b8;
}

/* On mouse-over, add a grey background color */
.customcheck:hover input ~ .checkmark {
  background-color: #eee;
}

/* When the checkbox is checked, add a blue background */
.customcheck input:checked ~ .checkmark {
  background-color: #ffffff;
  border-radius: 0px;
  border: solid 3px #169a5a;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.customcheck input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.customcheck .checkmark:after {
  left: 6px;
  top: 3px;
  width: 10px;
  height: 12px;
  border: solid 2px #169a5a;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.msg-error {
  color: #181918;
  font-size: 14px;
  font-weight: lighter;
  text-align: left;
}
.box-error {
  padding: 1%;
  background: #f6db00;
}

.bordes-detalles-auto {
  border-right: black solid 1px;
}

.readonly-option {
  pointer-events: none;
}
</style>
